import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "thumbnailGenerator"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "fieldLabel"
};
const _hoisted_4 = {
  key: 0,
  class: "instructionsLoading"
};
const _hoisted_5 = {
  class: "fieldLabel"
};
const _hoisted_6 = {
  class: "advancedRow"
};
const _hoisted_7 = {
  class: "advancedLabelGroup"
};
const _hoisted_8 = {
  class: "fieldLabel noMargin"
};
const _hoisted_9 = {
  class: "advancedSwitchWrapper"
};
const _hoisted_10 = {
  class: "advancedDescription"
};
const _hoisted_11 = {
  key: 1,
  class: "generatingStep"
};
const _hoisted_12 = {
  class: "generatingLabel"
};
const _hoisted_13 = {
  class: "progressWrapper"
};
const _hoisted_14 = {
  key: 2,
  class: "previewStep"
};
const _hoisted_15 = {
  class: "previewWrapper"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "thumbnailGeneratorFooter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_input = _resolveComponent("w-input");
  const _component_loader = _resolveComponent("loader");
  const _component_w_select = _resolveComponent("w-select");
  const _component_ai_credits_tool_tip = _resolveComponent("ai-credits-tool-tip");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_w_progress = _resolveComponent("w-progress");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_icon = _resolveComponent("icon");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.isVisible,
    title: _ctx.$t('thumbnailGenerator.title'),
    width: "560px",
    onOnDialogClose: _cache[2] || (_cache[2] = $event => _ctx.close())
  }, _createSlots({
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_ctx.step === 'prompt' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('thumbnailGenerator.customInstructions')), 1), _createVNode(_component_w_input, {
      class: "instructionsInput",
      type: "textarea",
      rows: 4,
      maxlength: 800,
      value: _ctx.instructions,
      placeholder: _ctx.$t('thumbnailGenerator.customInstructionsPlaceholder'),
      onInput: _ctx.onInstructionsInput
    }, null, 8, ["value", "placeholder", "onInput"]), _ctx.instructionsLoading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_loader, {
      "spinner-size": "spinnersSmall"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('thumbnailGenerator.buildingInstructions')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('thumbnailGenerator.imageStyle')), 1), _createVNode(_component_w_select, {
      class: "styleSelect",
      value: _ctx.styleSelected,
      options: _ctx.imageStyles,
      onChange: _cache[0] || (_cache[0] = $event => _ctx.styleSelected = $event)
    }, null, 8, ["value", "options"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('thumbnailGenerator.advancedGeneration')), 1), _createVNode(_component_ai_credits_tool_tip)]), _createVNode(_component_w_tool_tip, {
      text: _ctx.$t('thumbnailGenerator.noCreditsContactAdmin'),
      disabled: _ctx.aiCreditsAvailable
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_switch, {
        modelValue: _ctx.advanced,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.advanced = $event),
        disabled: !_ctx.aiCreditsAvailable
      }, null, 8, ["modelValue", "disabled"])])]),
      _: 1
    }, 8, ["text", "disabled"])]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('thumbnailGenerator.advancedGenerationDescription')), 1)])) : _ctx.step === 'generating' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('thumbnailGenerator.generating')), 1), _createElementVNode("div", _hoisted_13, [_createVNode(_component_w_progress, {
      class: "progress",
      percentage: _ctx.progressValue,
      "show-text": false,
      "stroke-width": 18
    }, null, 8, ["percentage"]), _createElementVNode("span", {
      class: _normalizeClass(["progressPercentage", {
        overFill: _ctx.progressValue >= 50
      }])
    }, _toDisplayString(_ctx.progressValue) + "%", 3)])])) : _ctx.step === 'preview' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
      src: _ctx.previewImageUrl,
      class: "previewImage",
      alt: "Generated thumbnail"
    }, null, 8, _hoisted_16)])])) : _createCommentVNode("", true)])]),
    _: 2
  }, [_ctx.step !== 'generating' ? {
    name: "footer",
    fn: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_ctx.step === 'preview' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('thumbnailGenerator.edit'),
      onAction: _ctx.backToPrompt
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      loading: _ctx.saving,
      onAction: _ctx.validate
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        icon: "check"
      }), _createTextVNode(" " + _toDisplayString(_ctx.$t('thumbnailGenerator.validate')), 1)]),
      _: 1
    }, 8, ["loading", "onAction"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('thumbnailGenerator.cancel'),
      onAction: _ctx.close
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      disabled: _ctx.instructionsLoading || !_ctx.instructions.trim(),
      onAction: _ctx.generate
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('thumbnailGenerator.generate')), 1)]),
      _: 1
    }, 8, ["disabled", "onAction"])], 64))])]),
    key: "0"
  } : undefined]), 1032, ["visible", "title"]);
}